import { useTopCollections } from "../hooks/useTopCollections";
import { MapBounds, TopCollectionStats } from "../../../api/admin";
import { parseCloudinaryUrl } from "../../../utils/util";
import DSTableContainer from "../../system-design/Table/DSTableContainer";
import DSTable from "../../system-design/Table/DSTable";
import DSTableHead from "../../system-design/Table/DSTableHead";
import DSTableBody from "../../system-design/Table/DSTableBody";
import DSTableRow from "../../system-design/Table/DSTableRow";
import DSTableCell from "../../system-design/Table/DSTableCell";
import DSBox from "../../system-design/DSBox";
import {
  LoadingState,
  ErrorState,
  EmptyState,
  SummaryBar,
  MEDIA_STYLE,
  ID_CELL_STYLE,
} from "./StatsDialog";

type CollectionStatsContentProps = {
  bounds: MapBounds;
  limit: number;
  open: boolean;
  isGlobal: boolean;
};

const CollectionsTable = ({
  collections,
}: {
  collections: TopCollectionStats[];
}) => (
  <DSTableContainer>
    <DSTable>
      <DSTableHead>
        <DSTableRow>
          <DSTableCell>Cover</DSTableCell>
          <DSTableCell>Collection Name</DSTableCell>
          <DSTableCell>Collection ID</DSTableCell>
          <DSTableCell align="right">Usage Count</DSTableCell>
        </DSTableRow>
      </DSTableHead>
      <DSTableBody>
        {collections.map((collection) => (
          <DSTableRow key={collection.collectionId}>
            <DSTableCell>
              <img
                src={parseCloudinaryUrl({
                  url: collection.coverUrl,
                  size: 100,
                })}
                alt={collection.name}
                style={MEDIA_STYLE}
              />
            </DSTableCell>
            <DSTableCell>{collection.name}</DSTableCell>
            <DSTableCell sx={ID_CELL_STYLE}>
              {collection.collectionId}
            </DSTableCell>
            <DSTableCell align="right">
              <DSBox sx={{ fontWeight: "bold", color: "primary.main" }}>
                {collection.usageCount}
              </DSBox>
            </DSTableCell>
          </DSTableRow>
        ))}
      </DSTableBody>
    </DSTable>
  </DSTableContainer>
);

const CollectionStatsContent = ({
  bounds,
  limit,
  open,
  isGlobal,
}: CollectionStatsContentProps) => {
  const { topCollections, totalCount, isLoading, isFetching, error } =
    useTopCollections(bounds, limit, open, isGlobal);

  if (isLoading || isFetching) return <LoadingState />;
  if (error) return <ErrorState message={error.message} />;

  return (
    <>
      <SummaryBar
        itemCount={topCollections.length}
        totalCount={totalCount}
        tabLabel="collections"
      />
      {topCollections.length === 0 ? (
        <EmptyState isGlobal={isGlobal} type="collections" />
      ) : (
        <CollectionsTable collections={topCollections} />
      )}
    </>
  );
};

export default CollectionStatsContent;
